/* eslint @okta/okta-ui/no-specific-methods: 0, @okta/okta-ui/no-specific-modules: 0 */
import Handlebars from 'handlebars';
import underscore from 'underscore';

const _ = underscore.noConflict();

_.mixin({
  resultCtx: function (object, property, context, defaultValue) {
    let value = _.isObject(object) ? object[property] : void 0;

    if (_.isFunction(value)) {
      value = value.call(context || object);
    }
    if (value) {
      return value;
    } else {
      return !_.isUndefined(defaultValue) ? defaultValue : value;
    }
  },

  isInteger: function (x) {
    return _.isNumber(x) && x % 1 === 0;
  },

  // TODO: This will be deprecated at some point. Views should use precompiled templates
  // eslint-disable-next-line @okta/okta-ui/no-bare-templates
  template: function (source, data) {
    const template = Handlebars.compile(source);

    return data
      ? template(data)
      : function (data) {
        return template(data);
      };
  }
});

export default _;



// WEBPACK FOOTER //
// ./node_modules/@okta/courage/src/util/underscore-wrapper.js


// WEBPACK FOOTER //
// webpack:///node_modules/@okta/courage/src/util/underscore-wrapper.js